import React from "react";
import { Input as ShadcnInput } from '../ui/Input';
import { formatMileage } from "../../utils/formatters";
import { cn } from "@/lib/utils";

interface MileageInputProps {
 value: string;
 onChange: (value: string) => void;
 placeholder?: string;
 disabled?: boolean;
 className?: string;
}

export const MileageInput: React.FC<MileageInputProps> = ({
 value,
 onChange,
 placeholder = "0",
 disabled = false,
 className = "",
}) => {
 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
 const formatted = formatMileage(e.target.value);
 onChange(formatted);
 };

 return (
 <ShadcnInput
 type="text"
 value={value}
 onChange={handleChange}
 placeholder={placeholder}
 disabled={disabled}
 className={cn(className)}
 />
 );
};
